import { useRouter } from 'next/router'

import { useIntl } from 'react-intl'

import { isOfType } from 'app/utils/helpers/type.helpers'

import NextSeo from '~/containers/NextSeo'

import SearchSection from './components/SearchSection'
import { metaData } from './utils/metaData'

const CategoryView = () => {
  const { formatMessage } = useIntl()
  const { query } = useRouter()

  const category = isOfType.string(query?.category) ? query?.category : ''

  const meta = metaData[category] ?? metaData.default

  return (
    <>
      <NextSeo
        title={formatMessage(meta.title)}
        description={formatMessage(meta.description)}
      />

      <SearchSection searchCategory={category} />
    </>
  )
}

export default CategoryView
